import { Link } from '@inertiajs/react';

// The "Info extra: hackatones pasadas" block, which both invite pages carry verbatim.
// The photo links are absolute over there (SITE_URL), so the origin arrives as a prop
// rather than being baked into the bundle (PORTING.md G6).
export function PastHacks({
  siteUrl,
  includeBogota = false,
}: {
  siteUrl: string;
  includeBogota?: boolean;
}) {
  const pastHacks = [
    {
      name: 'Hack 25',
      city: 'Santiago, Chile',
      dates: '21–23 nov 2025',
      landingUrl: '/25',
      photosUrl: `${siteUrl}/25/pics`,
      projectsUrl: '/25/vote',
    },
    {
      name: 'Hack 26: Buenos Aires',
      city: 'Buenos Aires, Argentina',
      dates: '8–10 may 2026',
      landingUrl: '/26-ar',
      photosUrl: `${siteUrl}/26-ar/pics`,
      projectsUrl: '/26-ar/vote',
    },
    {
      name: 'Hack 26: CDMX',
      city: 'Ciudad de México',
      dates: '19–21 jun 2026',
      landingUrl: '/26-mx',
      photosUrl: `${siteUrl}/26-mx/pics`,
      projectsUrl: '/26-mx/vote',
    },
    ...(includeBogota
      ? [
          {
            name: 'Hack 26: Bogotá',
            city: 'Bogotá, Colombia',
            dates: '21–23 ago 2026',
            landingUrl: '/26-co',
            photosUrl: `${siteUrl}/26-co/pics`,
            projectsUrl: '/26-co/vote',
          },
        ]
      : []),
  ];

  return (
    <section className="space-y-4">
      <h2 className="text-center font-bold text-sm uppercase tracking-wide">
        Info extra: hackatones pasadas
      </h2>
      <div className="space-y-3">
        {pastHacks.map((hack) => (
          <div
            key={hack.name}
            className="border-2 border-primary bg-background/80 p-5"
          >
            <div className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1">
              <p className="font-bold uppercase tracking-wide">{hack.name}</p>
              <p className="bg-primary px-2 py-0.5 font-mono font-semibold text-background text-xs uppercase tracking-wide">
                {hack.dates}
              </p>
            </div>
            <p className="mt-1 text-muted-foreground text-sm">{hack.city}</p>
            <div className="mt-3 flex flex-wrap gap-2">
              <Link
                href={hack.landingUrl}
                className="border border-primary/60 px-2 py-1 font-mono text-[11px] uppercase tracking-wide transition hover:bg-primary hover:text-background"
              >
                Landing
              </Link>
              <a
                href={hack.photosUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="border border-primary/60 px-2 py-1 font-mono text-[11px] uppercase tracking-wide transition hover:bg-primary hover:text-background"
              >
                Fotos
              </a>
              <Link
                href={hack.projectsUrl}
                className="border border-primary/60 px-2 py-1 font-mono text-[11px] uppercase tracking-wide transition hover:bg-primary hover:text-background"
              >
                Proyectos
              </Link>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
